module.exports = __webpack_public_path__ + "img/logo2.cf7084a2.svg";